import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/global.css'; // 引入全局CSS
import './styles/TierStyles.css'; // 引入段位样式
import App from './App';
import { ZoneProvider } from './contexts/ZoneContext';

// 创建根元素
const root = ReactDOM.createRoot(document.getElementById('root'));

// 输出当前路径，用于调试
console.log('Current Path:', window.location.pathname);

// 渲染应用
root.render(
  <BrowserRouter>
    <ZoneProvider>
      <App />
    </ZoneProvider>
  </BrowserRouter>
); 